import { Pipe, PipeTransform } from '@angular/core';
import { InfosService } from '../services/infos.service';

@Pipe({
  name: 'ethPrice',
  standalone: true,
})
export class EthPricePipe implements PipeTransform {

  private _polPrice: number | null = null;

  constructor(private readonly infosService: InfosService) {
    this.infosService.onChangePolPrice.subscribe((polPrice) => {
      this._polPrice = polPrice;
    });
  }

  transform(value: number | null): string {
    if (this._polPrice) {
      if (value === null) {
        return '';
      } else if (value < 0) {
        return '0';
      } else {
        return (value * this._polPrice).toFixed(2);
      }
    } else {
      return '';
    }
  }
}